export const addressToLines = (address: string): string[] =>
    address
        .split(' ')
        .slice(0, address.split(' ').length - 2)
        .join(' ')
        .split(',');

export const POSTCODE_REGEX =
    /^\s*([A-Z]{1,2}[0-9][0-9A-Z]?)\s*([0-9][A-Z]{2})\s*$/i;

export const postcodeToOutcode = (postcode: string): string | null => {
    const matches = postcode.match(POSTCODE_REGEX);

    if (!matches) {
        return null;
    }

    return matches[1].toUpperCase();
};

export const formatPostcode = (postcode: string): string => {
    const matches = postcode.match(POSTCODE_REGEX);

    return matches
        ? `${matches[1].toUpperCase()} ${matches[2].toUpperCase()}`
        : postcode;
};
export const formatAddress = (address: string[], postcode: string): string => {
    return `${address.join(', ')}, ${formatPostcode(postcode)}`;
};
